import { withInstall } from '@hongluan-ui/utils'
import Button from './src/button.vue'

export const HlButton = withInstall(Button)
export default HlButton

export * from './src/button'
export type { ButtonInstance } from './src/instance'
